import { useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

export function Footer() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || busy) return;
    setBusy(true);
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/leads`,
        { email: email.trim() }
      );
      toast.success(
        data.duplicate
          ? 'You are already on the list!'
          : "You're on the list — first draw alerts coming soon."
      );
      setEmail('');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Something went wrong — try again');
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-[#050505] px-6 pb-12 pt-28 md:px-16 lg:px-24" data-testid="site-footer">
      <div className="mx-auto max-w-6xl">
        <div className="grid gap-16 lg:grid-cols-2">
          <div>
            <p className="text-xs uppercase tracking-[0.35em] text-[#D4AF37]">Never miss a draw</p>
            <h2 className="font-serif-lux mt-4 text-4xl font-medium text-[#F5F5F5] lg:text-5xl">
              The wheel turns four times a day.
            </h2>
          </div>
          <form onSubmit={submit} className="flex items-end gap-4 self-end">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              data-testid="footer-email-input"
              className="w-full rounded-none border-b border-[#333333] bg-transparent px-0 py-3 text-white outline-none transition-colors duration-300 placeholder:text-[#666666] focus:border-[#D4AF37] focus:ring-0"
            />
            <button
              type="submit"
              data-testid="footer-notify-button"
              className="group flex shrink-0 items-center gap-2 rounded-sm bg-[#D4AF37] px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-black transition-colors duration-300 hover:bg-[#F9DF9F]"
            >
              Notify me
              <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </form>
        </div>

        <motion.p
          className="font-display mt-28 select-none text-center uppercase leading-none"
          style={{
            fontSize: 'clamp(3rem, 12.5vw, 12rem)',
            background: 'linear-gradient(180deg, #F9DF9F 0%, #D4AF37 55%, #5c4a10 100%)',
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            color: 'transparent',
          }}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
          data-testid="footer-brandmark"
        >
          Goldenraja
        </motion.p>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-[11px] uppercase tracking-[0.2em] text-[#666666] sm:flex-row">
          <span>© 2026 Golden Raja · Gangtok, Sikkim</span>
          <span>Demo experience — draw results are simulated</span>
        </div>
      </div>
    </footer>
  );
}
